export default __webpack_public_path__ + "static/media/discord_line.0e93492b.svg";